function pad(value) {
  return String(value).padStart(2, '0')
}

function digits(value, limit) {
  return String(value ?? '').replace(/\D/g, '').slice(0, limit)
}

function joinParts(value, lengths, separator) {
  const parts = []
  let offset = 0
  for (const length of lengths) {
    if (offset >= value.length) break
    parts.push(value.slice(offset, offset + length))
    offset += length
  }
  return parts.join(separator)
}

export function maskReceiptDate(value) {
  return joinParts(digits(value, 8), [2, 2, 4], '.')
}

export function maskReceiptTime(value) {
  return joinParts(digits(value, 6), [2, 2, 2], ':')
}

export function isReceiptDateValid(value) {
  const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(value ?? ''))
  if (!match) return false
  const day = Number(match[1])
  const month = Number(match[2])
  const year = Number(match[3])
  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

export function isReceiptTimeValid(value) {
  const match = /^(\d{2}):(\d{2}):(\d{2})$/.exec(String(value ?? ''))
  return Boolean(match && Number(match[1]) <= 23 && Number(match[2]) <= 59 && Number(match[3]) <= 59)
}

export function parseReceiptDateTime(dateText, timeText) {
  const dateValue = String(dateText ?? '').trim()
  const timeValue = String(timeText ?? '').trim()
  if (!dateValue && !timeValue) return ''
  if (!dateValue || !timeValue) throw new Error('incomplete_date_time')

  const dateMatch = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(dateValue)
  if (!dateMatch || !isReceiptDateValid(dateValue)) throw new Error('invalid_date')
  const timeMatch = /^(\d{2}):(\d{2}):(\d{2})$/.exec(timeValue)
  if (!timeMatch || !isReceiptTimeValid(timeValue)) throw new Error('invalid_time')

  const day = Number(dateMatch[1])
  const month = Number(dateMatch[2])
  const year = Number(dateMatch[3])
  const hours = Number(timeMatch[1])
  const minutes = Number(timeMatch[2])
  const seconds = Number(timeMatch[3])
  const local = new Date(year, month - 1, day, hours, minutes, seconds, 0)
  return local.toISOString()
}

export function formatReceiptDateTime(value) {
  if (!value) return { date: '', time: '' }
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return { date: '', time: '' }
  return {
    date: `${pad(parsed.getDate())}.${pad(parsed.getMonth() + 1)}.${parsed.getFullYear()}`,
    time: `${pad(parsed.getHours())}:${pad(parsed.getMinutes())}:${pad(parsed.getSeconds())}`,
  }
}

export function validateReceiptRange(from, to) {
  if (!from || !to) return true
  const fromTime = new Date(from).getTime()
  const toTime = new Date(to).getTime()
  return Number.isFinite(fromTime) && Number.isFinite(toTime) && fromTime < toTime
}
